import axios from "axios";

// The base domain for this deployment, set per environment in .env:
//   local dev  → talenton.test
//   staging    → app.talenton.io
//   mvp        → mvp.talenton.io
//   production → talenton.app
const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || 'app.talenton.io';

/**
 * Extract the tenant slug from the current hostname.
 *
 * Examples (BASE_DOMAIN = app.talenton.io):
 *   test.app.talenton.io  → "test"
 *   app.talenton.io       → null  (master portal)
 *
 * Examples (BASE_DOMAIN = talenton.app):
 *   test.talenton.app     → "test"
 *   talenton.app          → null  (master portal)
 */
export function getSubdomain() {
    const hostname = window.location.hostname;

    if (hostname.endsWith(`.${BASE_DOMAIN}`)) {
        return hostname.slice(0, hostname.length - BASE_DOMAIN.length - 1) || null;
    }

    // Fallback for dev environments not matching BASE_DOMAIN (e.g. localhost)
    const parts = hostname.split('.');
    if (parts.length > 2) return parts[0];
    return null;
}

/**
 * Returns true if this hostname is the master portal (no tenant subdomain).
 */
export function isMasterDomain() {
    const hostname = window.location.hostname;
    return (
        hostname === BASE_DOMAIN ||
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        !hostname.endsWith(`.${BASE_DOMAIN}`)
    );
}

const getAllDomain = async () => {
    const res = await axios.get('api/app-owner/get-subdomain', { params: {} });
    return res.data;
};

/**
 * Returns true if the current hostname is either the master portal
 * or a registered tenant subdomain.
 */
export async function IsValidSubdomain() {
    const hostname = window.location.hostname;

    // Master portal or non-subdomain host (local dev, etc.) — always valid
    if (isMasterDomain()) return true;

    // It's a *.BASE_DOMAIN subdomain — verify it's registered
    const subdomain = getSubdomain();
    if (!subdomain) return false;

    try {
        const validSubdomains = await getAllDomain();
        return validSubdomains && validSubdomains.includes(subdomain);
    } catch (error) {
        console.error('Error fetching valid subdomains:', error);
        return true; // Fail open so a backend error doesn't lock out users
    }
}
